const accountSwitchModalTemplate = `
<div class="align-checkbox">
    <div ng-if="!isEmulatorCallLoaded" style="width: 100%; height: 210px">
        <div id="frame-container-spinner" class="loaderBackground just-element">
            <div class="loader"></div>
        </div>
    </div>
    <div ng-if="isContinueCalled" style="width: 100%">
        <div id="frame-container-spinner" class="loaderBackground just-element">
            <div class="loader"></div>
        </div>
    </div>
    <div ng-if="isEmulatorCallLoaded && displayPage">
        <div class="modal-header auto-increase">
            <div class="modal-title">
                {{ 'header.contextSwitchModal.title' | translate }}
            </div>
            <hr class="hr-auto-increase" />
        </div>
        <div class="modal-body auto-increase">
            <div class="row">
                <div class="col-sm-12">
                    <p>
                        {{ 'header.contextSwitchModal.content' | translate }}
                        {{currentAccount.planName}} {{
                        'header.contextSwitchModal.to' | translate }}
                        {{clickedAccount.planName}}
                    </p>
                </div>
            </div>
            <div ng-if="!isEmulator">
                <div ng-if="!hasSameIndId">
                    <input
                        type="checkbox"
                        name="default-plan"
                        id="default-plan"
                        ng-model="switchPlanCtrl.updatePlanCheckbox"
                        ng-checked="switchPlanCtrl.updatePlanCheckbox"
                        ng-click="switchPlanCtrl.checkdefaultPlan()"
                    />
                    {{ 'header.contextSwitchModal.makePrimary' | translate }}
                    <span
                        uib-tooltip="{{ 'header.contextSwitchModal.tooltip' | translate }}"
                        tooltip-trigger="click focus mouseenter"
                        tooltip-placement="bottom"
                        tooltip-enable="true"
                    >
                        <a ng-href=""
                            >{{ 'header.contextSwitchModal.default' | translate
                            }}</a
                        > </span
                    >{{ 'header.contextSwitchModal.questionMark' | translate }}
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">&nbsp;</div>
            </div>
        </div>
        <div class="modal-footer auto-increase" ng-if="!hasSameIndId">
            <a
                href=""
                class="btn btn-link"
                ng-click="switchPlanCtrl.cancelSwitchPlan()"
                >{{ 'header.contextSwitchModal.cancel' | translate }}</a
            >
            <button
                type="button"
                class="btn btn-primary pull-right"
                ng-click="switchPlanCtrl.continueSwitchPlan(clickedAccount)"
            >
                {{ 'header.contextSwitchModal.continue' | translate }}
            </button>
        </div>
    </div>
</div>
`;
export default accountSwitchModalTemplate;
